import {
  Component,
  EventEmitter,
  HostListener,
  Input,
  OnInit,
  Output,
  OnChanges,
  SimpleChanges,
} from '@angular/core';
import { UserService } from '../../../services';
import { MapControlTask } from '../../../components/map-control/map-control.component';

const apiUrl = '/api/map';

@Component({
  selector: 'supplier-jobs-inbox-item-map',
  styleUrls: ['supplier-jobs-inbox-item-map.component.scss'],
  templateUrl: './supplier-jobs-inbox-item-map.component.html',
})
export class SupplierJobsInboxItemMapComponent implements OnChanges {
  @Input() taskMode: boolean = false;
  @Input() selectedTaskId: number;

  @Input() routeId: number;
  @Input() jobId: number;

  @Input() tasks: MapControlTask[];

  @Output() taskModeChange: EventEmitter<boolean> = new EventEmitter<boolean>();
  @Output() selectedTaskIdChange: EventEmitter<number | null> = new EventEmitter<number | null>();

  mapImageUrl: string;
  mapSize = '480x320';
  interactiveMap = false;

  constructor(public userService: UserService) {
    this.setMapSize();
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (
      changes['routeId'] ||
      changes['jobId'] ||
      changes['taskMode'] ||
      changes['selectedTaskId']
    ) {
      this.generateMapImageUrl();
    }
  }

  @HostListener('window:resize', ['$event'])
  onResize() {
    const oldMapSize = this.mapSize;
    this.setMapSize();
    if (oldMapSize !== this.mapSize) {
      this.generateMapImageUrl();
    }
  }

  private generateMapImageUrl(): void {
    if (!this.routeId && !this.jobId) {
      this.mapImageUrl = null;
      return;
    }

    const endpoint = `${apiUrl}/layeredStaticMapImage`;
    const params = new URLSearchParams();

    params.set('mapSize', this.mapSize);

    if (this.routeId) {
      params.set('routeId', this.routeId.toString());
    } else if (this.jobId) {
      params.set('jobId', this.jobId.toString());
    }

    if (this.taskMode && this.selectedTaskId) {
      params.set('primaryTaskId', this.selectedTaskId.toString());
    }

    this.mapImageUrl = `${endpoint}?${params.toString()}`;
  }

  setMapSize(): void {
    this.mapSize = window.innerWidth > 1400 || window.innerWidth <= 730 ? '480x320' : '280x320';
  }

  toggleTaskMode(event: MouseEvent, setTo: boolean): void {
    event.stopPropagation();
    event.preventDefault();

    this.taskModeChange.emit(setTo);

    const newSelectedId = setTo && this.tasks?.length > 0 ? this.tasks[0].id : null;
    this.selectedTaskIdChange.emit(newSelectedId);
  }

  goInteractive(): void {
    this.interactiveMap = true;
  }
}
